export interface SettingChemicalProp {
  chemicalName: string;
  molecularWeight: number | null;
  density: number | null;
  temperature: number | null;
  vaporPressure: number | null;
  emission: Emission;
  remark: string;
  _id: string;
}

export interface Emission {
  tvoc: number | null;
  bz: number | null;
  vcm: number | null;
  edc: number | null;
}

export interface FilterColumns {
  key: string;
  filter: (number | string)[];
}

export interface SettingLoadingMethod {
  _id: string;
  loadingBy: string;
  sFactor: number | null;
  remark: string;
}

export interface EmissionControl {
  _id: string;
  emissionControl: string;
  efficiency: number | null;
  remark: string;
}

export interface Filter {
  text: string;
  value: string;
}

export interface OptionFilter {
  key: string;
  filter: [];
}

export const initChemProp = {
  _id: "",
  chemicalName: "",
  molecularWeight: null,
  density: null,
  temperature: null,
  vaporPressure: null,
  emission: {
    tvoc: 100,
    bz: null,
    vcm: null,
    edc: null,
  },
  remark: "",
};

export const initLoadingMethod = {
  _id: "",
  loadingBy: "",
  sFactor: null,
  remark: "",
};

export const initEmissionControl = {
  _id: "",
  emissionControl: "",
  efficiency: null,
  remark: "",
};
